import { Message } from 'element-ui';
import store from '@/store/index';
import constants from "@/utils/constants";

function linkLogin() {
  window.location.href = `${constants.VUE_APP_AUTH_URL}/oauth/authorize?response_type=code&client_id=100002&redirect_uri=${window.location.origin}`;
}

const obj = {
  404: (msg) => {

  },
  401: () => {
    // Message.error('登录已过期');
    localStorage.removeItem("token");
    localStorage.removeItem("uid");
    localStorage.permission = [];
    store.state.permission = [];
    linkLogin();
  },
  default: (msg) => {
    if (!msg) return;
    Message.error(msg);
  }
};

export default function(res) {
  if (Object.prototype.hasOwnProperty.call(obj, res.code)) {
    obj[res.code](res.msg);
    return;
  }
  obj.default(res.msg || '请求失败');
}
